/* eslint-disable jsx-a11y/href-no-hash */
import React, { Component } from 'react'
import moment from 'moment'
import { Collapse, Pagination, Menu, Dropdown, Icon } from 'antd'
import { drop } from 'lodash'

const { Panel } = Collapse
const { Item } = Menu

const menu = (setFilter, currentFilter) => (
  <Menu>
    <Item onClick={() => setFilter('All')}>
      All {currentFilter === 'All' && <Icon type="check" />}
    </Item>
    <Item onClick={() => setFilter('Completed')}>
      Complete {currentFilter === 'Completed' && <Icon type="check" />}
    </Item>
    <Item onClick={() => setFilter('Not Complete')}>
      Not Complete {currentFilter === 'Not Complete' && <Icon type="check" />}
    </Item>
  </Menu>
)

class Leads extends Component {
  constructor(props) {
    super(props)
    this.state = {
      page: 1,
      filter: 'All'
    }
  }
  setFilter = filter => {
    this.setState({
      filter,
      page: 1
    })
  }
  setPage = page => {
    this.setState({
      page
    })
  }
  renderElement = data => {
    const { name, type, created_date, id } = data
    const date = moment(created_date).format('M/D/YYYY')
    return (
      <Panel key={id} header={name}>
        <div className="row">
          <div className="col-md-2">
            <div className="jobDetailsHeader">Name:</div>
            <span>{name}</span>
          </div>
          <div className="col-md-2">
            <div className="jobDetailsHeader">Type:</div>
            <span>{type}</span>
          </div>
          <div className="col-md-4">
            <div className="jobDetailsHeader">Date created:</div>
            <span>{date}</span>
          </div>
        </div>
      </Panel>
    )
  }
  getFilteredData = () => {
    const data = this.props.companyLeads || []
    const { filter } = this.state
    if (filter === 'All') {
      return data
    } else if (filter === 'Completed') {
      return data.filter(f => f.completed !== null)
    } else {
      // Not completed
      return data.filter(f => f.completed === null)
    }
  }
  getPagedData = () => {
    const { page } = this.state
    const data = this.getFilteredData()
    const offset = (page - 1) * 5
    return drop(data, offset).slice(0, 5)
  }
  render() {
    return (
      <div>
        <div className="row">
          <div className="col-md-12">
            <div className="jobsBar">
              Leads
              <div className="pull-right">
                <Dropdown overlay={menu(this.setFilter, this.state.filter)}>
                  <a className="ant-dropdown-link" href="#" style={{ color: '#fff' }}>
                    Filter by status <Icon type="down" />
                  </a>
                </Dropdown>
              </div>
            </div>
          </div>
        </div>
        <Collapse>{this.getPagedData().map(this.renderElement)}</Collapse>
        <Pagination
          total={this.getFilteredData().length}
          pageSize={5}
          current={this.state.page}
          defaultCurrent={1}
          onChange={this.setPage}
        />
      </div>
    )
  }
}

export default Leads



// WEBPACK FOOTER //
// ./src/components/company/Leads.js